export default __webpack_public_path__ + "static/syracuse-aa1cf8589aaefaf7cae123f920a74268.svg";